import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'
import { createFileRoute } from '@tanstack/react-router'
import { findAllUsers } from '@/api/users-api'
import { userKeys } from '@/hooks/users/query-keys'

export const Route = createFileRoute('/_authenticated/org/$orgId/users/')({
  beforeLoad() {
    requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER])
  },
  loader: async ({ params: { orgId }, context: { queryClient } }) => {
    return await queryClient.ensureQueryData({
      queryKey: userKeys.list(orgId),
      queryFn: () => findAllUsers(),
    })
  },
})
